import { useMemo } from 'react';

import { BUILDER_MODELS } from '~/builder/constants/models';
import useBuilderJson from '~/builder/utils/useBuilderJson';

export default function useEmbroideryConfigs() {
  const embroideryConfig = useBuilderJson({
    modelName: BUILDER_MODELS.EMBROIDERY_CONFIG,
  } as any);

  return useMemo(() => {
    return embroideryConfig?.builderJson?.data?.config || [];
  }, [embroideryConfig]);
}
